import React, { useState } from 'react';
import Header from 'layout/atoms/Header/Header';
import styles from './PercentageBar.module.scss';
function PercentageBar({ title, segments }) {
    const [tooltip, setTooltip] = useState({
        visible: false,
        x: 0,
        y: 0,
        content: '',
    });
    const total = segments.reduce((sum, seg) => sum + seg.value, 0);
    const handleSegmentMouseEnter = (e, label, percentage) => {
        const rect = e.currentTarget.getBoundingClientRect();
        setTooltip({
            visible: true,
            x: rect.left + rect.width / 2,
            y: rect.top,
            content: `${label}: ${percentage.toFixed(1)}%`,
        });
    };
    const handleSegmentMouseLeave = () => {
        setTooltip((prev) => (Object.assign(Object.assign({}, prev), { visible: false })));
    };
    return (React.createElement("div", { className: styles.wrapper },
        title && React.createElement(Header, { size: "m" }, title),
        React.createElement("div", { className: styles.progressBar }, segments.map((segment) => {
            const percentage = total > 0 ? (segment.value / total) * 100 : 0;
            return (percentage > 0 && (React.createElement("div", { key: segment.id, className: styles.progressSegment, style: {
                    width: `${percentage}%`,
                    backgroundColor: segment.color,
                }, onMouseEnter: (e) => handleSegmentMouseEnter(e, segment.label, percentage), onMouseLeave: handleSegmentMouseLeave })));
        })),
        tooltip.visible && (React.createElement("div", { className: styles.tooltip, style: {
                left: `${tooltip.x}px`,
                top: `${tooltip.y}px`,
            } }, tooltip.content)),
        React.createElement("div", { className: styles.legend }, segments.map((segment) => (React.createElement("div", { key: segment.id, className: styles.legendItem },
            React.createElement("span", { className: styles.legendDot, style: { backgroundColor: segment.color } }),
            segment.label))))));
}
export default PercentageBar;
